/** Valeur + bouton copier (même geste que le SIRET). */
import type { ReactNode } from "react";
import { CopyButton } from "../../components/CopyButton";

type CopyValueProps = {
  text: string;
  label: string;
  children: ReactNode;
};

export function CopyValue({ text, label, children }: CopyValueProps) {
  const value = text.trim();
  if (value === "") return <>{children}</>;
  return (
    <span className="fx-siret-val">
      {children}
      <CopyButton text={value} label={label} />
    </span>
  );
}
